import React from 'react';
import { format, parseISO } from 'date-fns';

// Shown when a scheduling request comes back 409.  Because an occupied timeslot renders no
// droppable, the user cannot normally aim at a filled slot, so a conflict means this browser's
// calendar is out of date rather than that the user did something invalid.  A reload is the actual
// remedy, so the one button performs it instead of asking the user to work that out.
const ScheduleConflictModal = ({ conflicts = [] }) => {
  const describe = conflict => {
    const slotLabel =
      conflict.calendarJobType === 'FLASHING'
        ? `flashing ${conflict.slot}`
        : `shoot ${conflict.slot}`;

    let day = conflict.scheduledDate;
    try {
      day = format(parseISO(conflict.scheduledDate), 'EEE M/d');
    } catch {
      // fall back to the raw date rather than breaking the message
    }

    return `${conflict.crewName} is already scheduled ${day}, ${slotLabel}${
      conflict.jobName ? ` for "${conflict.jobName}"` : ''
    }.`;
  };

  return (
    <div className='flex flex-col items-start w-fit lg:w-[460px] h-fit p-6 bg-white rounded-[8px]'>
      <div className='pb-6'>
        <div className='flex flex-row items-center'>
          <p className='text-[29px] font-bold text-secondary-blue'>This slot is already booked</p>
        </div>

        {conflicts.length ? (
          conflicts.map((conflict, i) => (
            <p className='text-[16px] text-light-blue' key={`conflict-${i}`}>
              {describe(conflict)}
            </p>
          ))
        ) : (
          <p className='text-[16px] text-light-blue'>
            Another job already holds that crew and timeslot.
          </p>
        )}

        <p className='pt-3 text-[16px] text-light-blue'>
          Nothing was changed. Your calendar is out of date — refresh to see the current schedule.
        </p>
      </div>

      <div className='flex w-full items-center justify-around'>
        <button
          className='rounded px-9 py-3 font-bold bg-gunite-red text-white'
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default ScheduleConflictModal;
